import Construction from '../images/industries/Administration.png';
    import Hospitality from '../images/industries/Hospitality.png';
    import RealEstate from '../images/industries/RealEstate.png';
    import Tourism from '../images/industries/Tourism.png';
    import Manufacturing from '../images/industries/Manufacturing.png';
    import Farming from '../images/industries/Farming.png';
    import Fishing from '../images/industries/Fishing.png';
    import Education from '../images/industries/Education.png';
    import PublicServices from '../images/industries/PublicServices.png';
    import Administration from '../images/industries/Administration.png';
    import Technology from '../images/industries/Technology.png';
    import Media from '../images/industries/Media.png';
    import FinancialServices from '../images/industries/FinancialServices.png';
    import Legal from '../images/industries/Legal.png';
    import HealthCare from '../images/industries/HealthCare.png';
    import Government from '../images/industries/Government.png';
    import Medical from '../images/industries/Medical.png';
    import Security from '../images/industries/Security.png';
    import Logistics from '../images/industries/Logistics.png';
    import Robotics from '../images/industries/Robotics.png';
    import Fashion from '../images/industries/Fashion.png';
    import Automotive from '../images/industries/Automotive.png';
    import Transportation from '../images/industries/Transportation.png';
    import CustomerServices from '../images/industries/CustomerService.png';


export var industries_list=[
    {
        name:"Construction",
        img:Construction,
        cb:"cb20"
    },
    {
        name:"Hospitality",
        img:Hospitality,
        cb:"cb21"
    },
    {
        name:"Real Estate",
        img:RealEstate,
        cb:"cb22"
    },
    {
        name:"Tourism",
        img:Tourism,
        cb:"cb23"
    },
    {
        name:"Manufacturing",
        img:Manufacturing,
        cb:"cb24"
    },
    {
        name:"Farming",
        img:Farming,
        cb:"cb25"
    },
    {
        name:"Fishing",
        img:Fishing,
        cb:"cb26"
    },
    {
        name:"Education",
        img:Education,
        cb:"cb27"
    },
    {
        name:"Public Services",
        img:PublicServices,
        cb:"cb28"
    },
    {
        name:"Administration",
        img:Administration,
        cb:"cb29"
    },
    {
        name:"Technology",
        img:Technology,
        cb:"cb30"
    },
    {
        name:"Media",
        img:Media,
        cb:"cb31"
    },
    {
        name:"Financial Services",
        img:FinancialServices,
        cb:"cb32"
    },
    {
        name:"Legal",
        img:Legal,
        cb:"cb33"
    },
    {
        name:"Health Care",
        img:HealthCare,
        cb:"cb34"
    },
    {
        name:"Government",
        img:Government,
        cb:"cb35"
    },
    {
        name:"Medical",
        img:Medical,
        cb:"cb36"
    },
    {
        name:"Security",
        img:Security,
        cb:"cb37"
    },
    {
        name:"Logistics",
        img:Logistics,
        cb:"cb38"
    },
    {
        name:"Robotics",
        img:Robotics,
        cb:"cb39"
    },
    {
        name:"Fashion",
        img:Fashion,
        cb:"cb40"
    },
    {
        name:"Automotive",
        img:Automotive,
        cb:"cb41"
    },
    {
        name:"Transportation",
        img:Transportation,
        cb:"cb42"
    },
    {
        name:"Customer Services",
        img:CustomerServices,
        cb:"cb43"
    }
]